import {
  clearAuthSession,
  getAccessToken as getSessionAccessToken,
  getAuthData,
} from './authUtils';
import { UserPermissionsMap } from '../apollo/queries/v3/RolesNPermissions/getPermissionsByUserId.queries';
import { AdminRole } from '../pages/AddAdminUser/hooks/useAddAdminUser';

const ALEF_USER_KEY = 'alef_user';

interface User {
  username: string;
  tenant: string;
  journey?: string;
  school?: string;
  uuid: string;
  onboarded: boolean;
  enabled: boolean;
  name: string;
  phoneNumber: string;
  roles: string[];
  role: string;
  avatar: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
}

interface Token {
  access_token: string;
}

interface AlefUser {
  user: User;
  token: Token;
}

class ApplocalStorage {
  getAlefUser(): AlefUser | null {
    const user = getAuthData() as AlefUser | null;
    return user ?? null;
  }

  setAlefUser(alefUser: AlefUser) {
    localStorage.setItem(ALEF_USER_KEY, JSON.stringify(alefUser));
  }

  clearAlefUser() {
    clearAuthSession();
  }

  getAccessToken(): string | undefined {
    return getSessionAccessToken();
  }

  getPermissions() {
    return localStorage.getItem('permissions');
  }

  getAdminUUID(): string | undefined {
    return this.getAlefUser()?.user.uuid;
  }

  isViewOnlyRole(): boolean {
    return this.getAlefUser()?.user.role === AdminRole.ALEF_CONSOLE_SUPPORT;
  }

  setUserPermissions(permissions: UserPermissionsMap) {
    localStorage.setItem('permissions', JSON.stringify(permissions));
  }

  getAlefCclUser() {
    return JSON.parse(localStorage.getItem('alef_ccl_user') || '{}');
  }

  setAlefCclUser(user: any) {
    localStorage.setItem(
      'alef_ccl_user',
      JSON.stringify({
        user: {
          ...user,
        },
      }),
    );
  }
}

const appLocalStorage = new ApplocalStorage();
export default appLocalStorage;
